import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ColorScheme } from "../../../../Themes/ColorScheme";

export const FormCancel = ({ cancelAction, disabled }) => {
	const { t } = useTranslation();

	return (
		<Button
			sx={{
				backgroundColor: ColorScheme.transparent,
				boxShadow: "none",
				padding: "2px",
				width: "100px",
				opacity: disabled ? 0.6 : 1,
				"&:hover": {
					backgroundColor: ColorScheme.transparent,
					boxShadow: "none",
					border: "1px solid white",
					padding: "2px"
				}
			}}
			variant="contained"
			onClick={() => cancelAction()}
			disabled={disabled}
		>
			<Typography sx={{ textTransform: "none" }}>{t("buttons.cancel")}</Typography>
		</Button>
	);
};
